import { withStyles } from "@material-ui/core/styles";
import { Paper, Typography, WithStyles } from "@material-ui/core";
import * as React from "react";
import { styles } from "./ProductSidebar.styles";

export interface ProductSidebarProps extends WithStyles<typeof styles> {
    datashopProductsInfo: any,
    a7ProductsInfo: any,
    sampleProductsInfo: any,
    categoryActive: string,
    subcategoryActive: string,
    venueActive: string,
    handleViewAll: any,
    setCategoryActive: any,
    setSubcategoryActive: any,
    setVenueActive: any
}

const ProductSidebarPure: React.FunctionComponent<ProductSidebarProps> = ({
    classes,
    datashopProductsInfo,
    a7ProductsInfo,
    sampleProductsInfo,
    categoryActive,
    subcategoryActive,
    venueActive,
    handleViewAll,
    setCategoryActive,
    setSubcategoryActive,
    setVenueActive
}: ProductSidebarProps) => {

    return <Paper className={classes.sidebar}>
        <ul>
            <li>
                <Typography
                    className={categoryActive === "" && venueActive === "" ? classes.menuActive : classes.menuInactive}
                    variant={"subtitle1"}
                    onClick={handleViewAll}>View all</Typography>
            </li>
        </ul>
        <Typography className={classes.sidebarTitle} variant={"subtitle1"}>Filter by product category</Typography>
        <ul>
            {datashopProductsInfo?.categories?.map(category =>
                <li key={category.id}>
                    <Typography className={categoryActive === category.id ? classes.menuActive : classes.menuInactive}
                                variant={"subtitle1"}
                                onClick={_event => setCategoryActive(categoryActive === category.id ? "" : category.id)}>{category.name}</Typography>
                    {categoryActive === category.id
                        ? category.subcategories.map(subcategory =>
                            <div key={subcategory.id}
                                 className={`${classes.subcategory} ${subcategoryActive === subcategory.id ? classes.subcategoryActive : classes.subcategoryInactive}`}>
                                <Typography
                                    variant={"subtitle1"}
                                    onClick={_event => setSubcategoryActive(categoryActive !== category.id ? "" : category.id, subcategory.id)}>{subcategory.name}</Typography>
                            </div>
                        )
                        : null}
                </li>)}
        </ul>
        <Typography className={classes.sidebarTitle} variant={"subtitle1"}>Filter by data source</Typography>
        <ul>
            {datashopProductsInfo?.venues?.map(venue => <li key={venue.id}>
                <Typography
                    className={venueActive === venue.id ? classes.menuActive : classes.menuInactive}
                    variant={"subtitle1"}
                    onClick={_event => setVenueActive(venueActive === venue.id ? "" : venue.id)}>{venue.name}</Typography>
            </li>)}
        </ul>
        <Typography className={classes.sidebarTitle} variant={"subtitle1"}>A7 Analytics</Typography>
        <ul>
            {a7ProductsInfo?.categories?.map(category =>
                <li key={category.id}>
                    <Typography className={categoryActive === category.id ? classes.menuActive : classes.menuInactive}
                                variant={"subtitle1"}
                                onClick={_event => setCategoryActive(categoryActive === category.id ? "" : category.id, true)}>{category.name}</Typography>
                    {categoryActive === category.id
                        ? category.subcategories.map(subcategory =>
                            <div key={subcategory.id}
                                 className={`${classes.subcategory} ${subcategoryActive === subcategory.id ? classes.subcategoryActive : classes.subcategoryInactive}`}>
                                <Typography
                                    variant={"subtitle1"}
                                    onClick={_event => setSubcategoryActive(categoryActive !== category.id ? "" : category.id, subcategory.id, true)}>{subcategory.name}</Typography>
                            </div>
                        )
                        : null}
                </li>)}
        </ul>
        <Typography className={classes.sidebarTitle} variant={"subtitle1"}>Sample Data</Typography>
        <ul>
            {sampleProductsInfo?.categories?.map(category =>
                <li key={category.id}>
                    <Typography className={categoryActive === category.id ? classes.menuActive : classes.menuInactive}
                                variant={"subtitle1"}
                                onClick={_event => setCategoryActive(categoryActive === category.id ? "" : category.id, false, true)}>{category.name}</Typography>
                    {categoryActive === category.id
                        ? category.subcategories.map(subcategory =>
                            <div key={subcategory.id}
                                 className={`${classes.subcategory} ${subcategoryActive === subcategory.id ? classes.subcategoryActive : classes.subcategoryInactive}`}>
                                <Typography
                                    variant={"subtitle1"}
                                    onClick={_event => setSubcategoryActive(categoryActive !== category.id ? "" : category.id, subcategory.id, false, true)}>{subcategory.name}</Typography>
                            </div>
                        )
                        : null}
                </li>)}
        </ul>
        
    </Paper>;
};

export const ProductSidebar = withStyles(styles)(ProductSidebarPure);